export default __webpack_public_path__ + "static/char-49-30c493525e6495d3df428ccff6246614.gif";